import { MessageCircle } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { WA_URL } from "@/constants/neco";
import { trackWhatsAppClick } from "@/lib/gtag";

export const FloatingWhatsApp = () => (
  <a
    href={WA_URL}
    target="_blank"
    rel="noopener noreferrer"
    onClick={trackWhatsAppClick}
    data-testid={HOME.floatingWhatsappButton}
    aria-label="WhatsApp ile yazın"
    className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#1ebe5d] text-white pl-4 pr-5 py-4 shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-colors duration-300"
  >
    <MessageCircle size={22} strokeWidth={1.8} fill="currentColor" className="text-white" />
    <span className="hidden sm:block text-xs uppercase tracking-[0.2em] font-semibold">
      WhatsApp'tan Yazın
    </span>
  </a>
);
